import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {ToastService} from "@app/_services/toast.service";
import {NgbToast} from "@ng-bootstrap/ng-bootstrap";
import {DangerToastDirective} from "@app/_directives/danger-toast.directive";
import {AsyncPipe} from "@angular/common";

@Component({
    selector: 'app-toasts-container',
    imports: [
        NgbToast,
        DangerToastDirective,
        AsyncPipe
    ],
    templateUrl: './toasts-container.component.html',
    styleUrl: './toasts-container.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    host: { class: 'toast-container position-fixed top-0 end-0 p-3', style: 'z-index: 1200' }
})
export class ToastsContainerComponent {
    toastService = inject(ToastService);
}
